"use strict";
var PolicyFlightOverride = (function () {
    function PolicyFlightOverride() {
    }
    return PolicyFlightOverride;
}());
exports.PolicyFlightOverride = PolicyFlightOverride;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/flight-reminder/policy-flight-override.model.js